/**
 * Two letter avatar fallback built from a display name.
 *
 * Shared by the global `$filtersGetInitial` template filter and by components
 * that need the initials in script instead of template.
 */
export function getInitial(name) {
  if (typeof name !== "string" || name.trim() === "") {
    return null;
  }
  const parts = name.trim().split(" ");
  const firstInitial = (parts[0] || " ").charAt(0);
  const secondInitial = parts.length > 1 ? (parts[1] || " ").charAt(0) : "";
  return firstInitial + secondInitial;
}
